import React from "react";
import Select, { components } from "react-select";
import "./selectDropdown.css";
import ArrowRight from "../../../../assets/images/ArrowRight.svg";

// Custom Option component to display the extra details inside the dropdown options
const CustomOption = ({ data, innerRef, innerProps }) => {
  console.log(data)
  return (
    <div ref={innerRef} {...innerProps} className="custom-option">
      <div className="custom-option-content">
        <span className="custom-option-text">{data.name}</span>
        <div className="custom-option-actions">
          <button 
            onClick={() => data.openPrompt({id:data.id,prompt_id:data?.data?.prompt_id,data:data})}
            className="custom-option-button"
          >
            View Details
          </button>
          <img src={ArrowRight} alt="right" className="custom-option-arrow" />
        </div>
      </div>
    </div>
  );
};

const SelectDropdown = ({
  options,
  value,
  onChange,
  onBlur,
  name,
  placeholder,
  isMulti,
  isDisabled,
  isPromptName,
  openPrompt,
  onDropdownClick,
}) => {
  const customStyles = {
    control: (provided, { isFocused, isHovered, isDisabled }) => ({
      // class attribute : class=" css-i32vvf-control"
      ...provided,
      // ...styles,
      borderColor: isFocused || isHovered ? "#4F46E5" : "#D1D5DB",
      boxShadow: isFocused ? "none" : "",
      background: isDisabled ? "#e9ecef" : "#ffffff",
      display: "flex",
      flexWrap: "nowrap",
      fontSize: "0.875rem",
      lineHeight: "1.25rem",
      height: "40px",
      
      borderRadius: 4,
      " &:hover": {
        borderColor: isHovered ? "#dee2e6" : "#D1D5DB",
      },
      "&:disabled": {
        borderColor: isDisabled ? "#d1d5db" : "#D1D5DB",
      },
    }),
    placeholder: (defaultStyles) => ({
      ...defaultStyles,
      color: "#A1AEBE",
    }),
    option: (styles, { isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isFocused ? "#F5F4FF" : "#fff",
        color: isFocused ? "#4F46E5" : "",
        cursor: isDisabled ? "not-allowed" : "default",
        borderWidth: isFocused ? "4px" : "0px",
        borderColor: "#4F46E5",
        borderStyle: "solid",
        borderTop: 0,
        borderLeft: 0,
        borderBottom: 0,
        fontSize: 14,
        fontWeight: isFocused ? 600 : 400,
        paddingVertical: 12,
        paddingHorizontal: 14,
        zIndex: 10000000,
      };
    },
    menu: (provided) => ({
      // 'menu' is from the div class too.
      ...provided,
      background: "#ffffff",
      padding: 10,
      border: "1px solid #A1AEBE",
      borderRadius: 8,
      boxShadow: "0px 0px 7px 0px rgba(0, 0, 0, 0.1)",
      zIndex: 9999,
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#4F46E5",
    }),
  };
  // Custom label to show only the name inside the dropdown, not the whole option structure
  const getOptionLabel = (option) => (
    <div className="flex justify-between items-center">
      <span>{option.name}</span>
    </div>
  );
   // Conditionally use CustomOption only for "prompt_name"
   const componentsToUse =isPromptName ? { Option: CustomOption } : {};

  // Add click handler
  const handleDropdownClick = () => {
    if (onDropdownClick) {
      onDropdownClick();
    }
  };

  return (
    <Select
      styles={customStyles}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      name={name}
      options={options}
      isMulti={isMulti}
      isDisabled={isDisabled}
      onMenuOpen={handleDropdownClick}
      components={componentsToUse}
      getOptionLabel={isPromptName ? getOptionLabel : undefined}
      formatOptionLabel={(option) => {
        if (isPromptName) {
          return (
            <div className="d-flex justify-content-between align-items-center">
              <span>{option.label}</span>
              
            </div>
          );
        }
        return option.label;
      }}
    />
  );
};

export default SelectDropdown;
